export default [
    {
      path: '/products',
      name: 'products-read',
      component: () => import('@/views/products/products-list/ProductsList.vue'),
      meta: {
        resource: 'Products',
        action: 'read',
      },
    },
    {
        path: '/products/create',
        name: 'products-create',
        component: () => import('@/views/blog/blog-form/BlogForm.vue'),
        meta: {
          resource: 'Products',
          action: 'create',
        },
    },
    {
      path: '/products-category',
      name: 'products-category-read',
      component: () => import('@/views/products/category-list/CategoryList.vue'),
      meta: {
        resource: 'Product Categories',
        action: 'read',
      },
    },
    {
        path: '/products-category/create',
        name: 'products-category-create',
        component: () => import('@/views/blog/blog-form/BlogForm.vue'),
        meta: {
          resource: 'Product Categories',
          action: 'create',
        },
    },
    
    
  ]
  